import { RandomGenerator } from "../test-utils";
var SiteDataBuilder = /** @class */ (function () {
    function SiteDataBuilder() {
        this.siteData = {
            siteInfo: {
                name: RandomGenerator.randomString(),
                editorLink: RandomGenerator.randomString(),
                createdDate: new Date(),
                msid: RandomGenerator.randomString(),
                userRoles: [RandomGenerator.randomString()],
                plan: RandomGenerator.randomString(),
                publicUrl: RandomGenerator.randomString(),
                isOnTrial: RandomGenerator.randomBoolean()
            },
            userActivity: {
                lastPublish: new Date(),
                publishCount: RandomGenerator.randomNumber(1, 100),
                lastSave: new Date(),
                sessionCount: RandomGenerator.randomNumber(1, 100)
            },
            toolsAndApps: {
                installed: [RandomGenerator.randomString()],
                mobileEditorOpened: RandomGenerator.randomBoolean(),
                mediaFiles: RandomGenerator.randomNumber(1, 100),
                membersArea: RandomGenerator.randomBoolean()
            },
            userOnBoarding: {
                templateName: RandomGenerator.randomString(),
                siteClassification: RandomGenerator.randomString(),
                category: RandomGenerator.randomString(),
                editorType: RandomGenerator.randomString()
            }
        };
    }
    SiteDataBuilder.prototype.withSiteInfo = function (siteInfo) {
        this.siteData.siteInfo = siteInfo;
        return this;
    };
    SiteDataBuilder.prototype.withUserActivity = function (userActivity) {
        this.siteData.userActivity = userActivity;
        return this;
    };
    SiteDataBuilder.prototype.withToolsAndApps = function (toolsAndApps) {
        this.siteData.toolsAndApps = toolsAndApps;
        return this;
    };
    SiteDataBuilder.prototype.withUserOnBoarding = function (userOnBoarding) {
        this.siteData.userOnBoarding = userOnBoarding;
        return this;
    };
    SiteDataBuilder.prototype.build = function () {
        return this.siteData;
    };
    return SiteDataBuilder;
}());
export { SiteDataBuilder };
//# sourceMappingURL=site-data.builder.js.map